import HookWrapper from "@common/components/HookWrapper";
import { WrapperProps } from "../DynamicWrapper";
import { useAppSelector } from "@builder/store/store";

const PaymentGridWrapper = (props: WrapperProps) => {
    const build = useAppSelector(state => state.builder.build);

    return (
        <HookWrapper
            {...props}
            builderProps={{
                ...props.builderProps,
                otherData: {
                    paymentGridSettings: build?.paymentGridSettings
                }
            }}
        />
    );
};

export default PaymentGridWrapper;
